
import React from "react";
import { Link } from "react-router-dom";

const range = (start, end) => Array.from({ length: end - start + 1 }, (_, i) => start + i);

function getPaginationRange({
  totalPages,
  currentPage,
  siblingCount = 1,
  boundaryCount = 1,
}) {
  const totalNumbers = boundaryCount * 2 + siblingCount * 2 + 3;
  const totalBlocks = totalNumbers + 2;

  if (totalPages <= totalNumbers) {
    return range(1, totalPages);
  }

  const leftSibling = Math.max(currentPage - siblingCount, 1);
  const rightSibling = Math.min(currentPage + siblingCount, totalPages);

  const showLeftDots = leftSibling > boundaryCount + 2;
  const showRightDots = rightSibling < totalPages - (boundaryCount + 1);

  const leftItems = range(1, boundaryCount);
  const rightItems = range(totalPages - boundaryCount + 1, totalPages);

  if (!showLeftDots && showRightDots) {
    const leftRange = range(1, boundaryCount + 2 + siblingCount * 2);
    return [...leftRange, "dots", ...rightItems];
  }

  if (showLeftDots && !showRightDots) {
    const rightRange = range(totalPages - (boundaryCount + 2 + siblingCount * 2) + 1, totalPages);
    return [...leftItems, "dots", ...rightRange];
  }

  const middleRange = range(leftSibling, rightSibling);
  return [...leftItems, "dots", ...middleRange, "dots", ...rightItems];
}

const ProPagination = ({
  totalPages,
  currentPage,
  onChange,
  disabled = false,
  siblingCount = 1,
  boundaryCount = 1,
}) => {
  if (!totalPages || totalPages <= 1) return null;

  const canPrev = !disabled && currentPage > 1;
  const canNext = !disabled && currentPage < totalPages;

  const items = getPaginationRange({ totalPages, currentPage, siblingCount, boundaryCount });

  const goto = (p) => (e) => {
    e.preventDefault();
    if (!disabled && p >= 1 && p <= totalPages && p !== currentPage) onChange(p);
  };

  return (
    <div className="pagination pagination-rounded justify-content-center mb-2 bg-transparent">
      <ul className="pagination">

        <li className={`page-item ${!canPrev ? "disabled" : ""}`}>
          <Link to="#" className="page-link" aria-label="First" onClick={goto(1)}>
            <i className="mdi mdi-page-first" />
          </Link>
        </li>

        <li className={`page-item ${!canPrev ? "disabled" : ""}`}>
          <Link to="#" className="page-link" aria-label="Previous" onClick={goto(currentPage - 1)}>
            <i className="mdi mdi-chevron-left" />
          </Link>
        </li>

        {items.map((it, idx) =>
          it === "dots" ? (
            <li key={`dots-${idx}`} className="page-item disabled">
              <span className="page-link">…</span>
            </li>
          ) : (
            <li key={it} className={`page-item ${currentPage === it ? "active" : ""}`}>
              <Link to="#" className="page-link" onClick={goto(it)}>
                {it}
              </Link>
            </li>
          )
        )}

        <li className={`page-item ${!canNext ? "disabled" : ""}`}>
          <Link to="#" className="page-link" aria-label="Next" onClick={goto(currentPage + 1)}>
            <i className="mdi mdi-chevron-right" />
          </Link>
        </li>

        <li className={`page-item ${!canNext ? "disabled" : ""}`}>
          <Link to="#" className="page-link" aria-label="Last" onClick={goto(totalPages)}>
            <i className="mdi mdi-page-last" />
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default ProPagination;
